import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getItemsFromCollection } from "directus/src/operations";
import { apiRoot } from "services/src/config";
import CommonCard from "components-v2/kpi/common-card";
import {
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  RadialBar,
  RadialBarChart,
  Tooltip,
} from "recharts";
import CountUp from "ui/components/CountUp";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";
import { TooltipInfo } from "components/info-tooltip";
import { KPI_DATA } from "@/modules/home/constants/info";
import { HOME_CARD_CONTENT } from "@/modules/home/constants";

export default function TaskEfficiencyCard({ onClick, cardData, tagId }) {
  const user = useSelector(selectUser);

  const { data, isLoading } = useQuery({
    queryKey: ["task-efficiency", user?.id, tagId],
    enabled: !!user?.id,
    queryFn: async () => {
      const response = await apiRoot.get("kpi/task-efficiency", {
        params: tagId ? { tagId } : undefined,
      });
      return response.data;
    },
    limit: -1,
  });

  const taskEfficiency = data?.taskEfficiency ?? 0;
  const totalTasks = data?.totalTasks ?? 0;
  const tasksCompletedOnTime = data?.tasksCompletedOnTime ?? 0;

  if (isLoading) return null;


  const { title, description } = HOME_CARD_CONTENT.taskEfficiency;

  return (
    <CommonCard
      title={title}
      info={description}
      onClick={onClick}
      cardData={{
        title: title,
        description: description,
        value: isLoading ? "0" : taskEfficiency.toFixed(1),
        unit: "%",
        details: [
          { label: "Total Tasks", value: totalTasks },
          {
            label: "Completed On Time",
            value: tasksCompletedOnTime,
          }
        ],
      }}
      percentage={taskEfficiency}
      isLoading={isLoading}
    />
  );
}
